<template>
  <div class="table_container">
    <el-row style="margin-bottom:10px">
      <el-form inline :model="searchForm">
        <el-form-item label="轮播名称">
          <el-input v-model="searchForm.slideName" placeholder="请输入轮播名称" size="medium"/>
        </el-form-item>
        <el-form-item style="position: absolute; right: -10px">
          <el-button type="warning" icon="el-icon-search" @click="handleSearchSubmit" size="medium">查询</el-button>
          <el-button type="info" icon="el-icon-refresh-left" @click="handleSearchReset" size="medium">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="medium">新建</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table highlight-current-row :data="tableData" v-loading="$store.state.loading" border>
        <el-table-column min-width="100" prop="slideName" label="轮播名称" align="center" fixed/>
        <el-table-column min-width="100" prop="beginTime" label="开始时间" align="center"/>
        <el-table-column min-width="100" prop="endTime" label="结束时间" align="center"/>
<!--        <el-table-column min-width="100" prop="slideHref" label="链接地址" align="center"/>-->
        <el-table-column width="200" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index,scope.row)" size="mini">编辑</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDelete(scope.$index,scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="table_pagination">
      <el-pagination background :pageCount="pageCount" :currentPage="currentPage" :page-size="pageSize"
                     layout="prev, pager, next" @current-change="handleCurPageChange"
                     hide-on-single-page/>
    </el-row>
    <info-slide-form ref="addInfoSlide" @refreshList="getTableData"/>
    <up-info-slide-form ref="upInfoSlide" :selRow="selRow" @refreshList="getTableData"/>
  </div>
</template>

<script>
import {deleteSlide, getSlideList} from "../../../api/core/infoSlide";
import InfoSlideForm from "./form/InfoSlideForm";
import UpInfoSlideForm from "./form/UpInfoSlideForm";

export default {
  name: "InfoSlide",
  components: {UpInfoSlideForm, InfoSlideForm},
  data() {
    return {
      tableData: [],
      searchForm: {},
      selRow: {},
      pageCount: 1,
      currentPage: 1,
      pageSize: 10,
      formVisible: false
    }
  },
  mounted() {
    this.getTableData();
  },
  methods:{
    handleCurPageChange(pageIndex) {
      if (pageIndex !== this.currentPage) this.currentPage = pageIndex;
      this.getTableData()
    },
    getTableData(){
      this.searchForm.pageNum = this.currentPage;
      this.searchForm.pageSize = this.pageSize;
      getSlideList(this.searchForm).then(res => {
        if (res.status == 200) {
          this.tableData = res.obj.list
          this.pageCount = res.obj.pages
        }
      })
    },
    // 查询
    handleSearchSubmit() {
      this.currentPage = 1;
      this.getTableData()
    },
    // 重置
    handleSearchReset() {
      this.searchForm = {}
    },
    //  新建
    handleAdd() {
      this.$refs.addInfoSlide.visible = true;
    },
    // 序号
    generSerialNum(index) {
      return (this.currentPage - 1) * 10 + index + 1
    },
    //  修改
    handleEdit(index, row) {
      this.selRow = row;
      this.selRow.time = [row.beginTime, row.endTime];
      this.$refs.upInfoSlide.visible = true;
    },
    //  删除
    async handleDelete(index, row) {
      let isConfirm = await this.$confirm("确认删除？", '提示', {type: 'warning'}).catch(() => {
      });
      if (!isConfirm) return;
      let params = {id: row.id};
      await deleteSlide(params);
      this.getTableData()
    },
    handleDetail(index, row) {
      this.selRow = row;
      this.detailVisible = true;
    },
  }
}
</script>

<style scoped>

</style>